import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link, useRouteMatch } from 'react-router-dom';
import { getScenarioList, ICON_BG } from './scenarioConfig';
import ScenarioIcon from './components/ScenarioIcon';

const ModelScenariosTab = () => {
  const { t } = useTranslation();
  const match = useRouteMatch();
  const SCENARIOS = getScenarioList(t);
  return (
    <Container fluid className="pt-4 px-4">
      <Row>
        <Col>
          <h5 className="mb-2">{t('Model Scenarios')}</h5>
          <p className="text-muted">
            {t('Select a scenario to model carbon reduction strategies and analyze financial and environmental impacts.')}
          </p>
        </Col>
      </Row>
      <Row>
        {SCENARIOS.map((s) => (
          <Col key={s.key} sm={12} md={6} lg={4} className="mb-4">
            <Card className="h-100 text-center">
              <Card.Body>
                {/* ICON */}
                <div className="mb-3 d-flex justify-content-center">
                  <div
                    className="rounded-6 d-flex align-items-center justify-content-center"
                    style={{
                      width: 64,
                      height: 64,
                      backgroundColor: ICON_BG[s.color],
                    }}
                  >
                    <ScenarioIcon
                      type={s.icon}
                      className={`text-${s.color}`}
                      style={{ width: 28, height: 28 }}
                    />
                  </div>
                </div>

                {/* CONTENT */}
                <h6 className="mb-2">{s.title}</h6>
                <p className="text-muted small mb-0">{s.desc}</p>
              </Card.Body>

              {/* BUTTON */}
              <Card.Footer className="bg-white border-0">
                <Button variant="success" block as={Link} to={`${match.url}/${s.key}`}>
                  {t('Start Modeling')}
                </Button>
              </Card.Footer>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default ModelScenariosTab;
